// Default font width in pixels if it cannot be retrieved from the context
export var DEFAULT_FONT_WIDTH = 10;

/**
 * Props passed to a cell input renderer, combining the base CellInputField
 * props with the restrictions that apply to the cell being edited.
 */

/**
 * A renderer for a single cell input field based on column restriction type.
 *
 * Set `preservesExistingValue = true` on the function to signal that
 * keystroke-initiated edits should open the editor with the existing cell
 * value rather than replacing it with the typed character.
 */

/**
 * A map from column restriction type string to a cell input renderer function.
 * Grid looks up restrictions[0].type in this registry and falls back to
 * CellInputField when there is no match.
 */
//# sourceMappingURL=GridRendererTypes.js.map